import AutologinEmailConfirmError from './AutologinEmailConfirmError';

export default AutologinEmailConfirmError;
